"use strict";
// Font Variant property parser
// Handles parsing of CSS font-variant property values
// https://developer.mozilla.org/en-US/docs/Web/CSS/font-variant
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
exports.toCSSValue = toCSSValue;
const shared_utils_1 = require('../utils/shared-utils.cjs');
const css_variable_1 = require('./css-variable.cjs');
// Import centralized types
const types_1 = require('../types.cjs');
/**
 * Parse a CSS font-variant property string
 */
function parse(value) {
    if (!value || typeof value !== 'string') {
        return null;
    }
    const trimmed = value.trim();
    if (trimmed === '') {
        return null;
    }
    // CSS variables - parse and return directly
    if ((0, shared_utils_1.isCssVariable)(trimmed)) {
        return (0, css_variable_1.parse)(trimmed);
    }
    // Handle global keywords
    if ((0, shared_utils_1.isGlobalKeyword)(trimmed)) {
        return { type: 'keyword', keyword: trimmed.toLowerCase() };
    }
    // Handle font-variant keywords
    const fontVariantKeyword = (0, shared_utils_1.getValidKeyword)(trimmed, types_1.FONT_VARIANT_KEYWORDS);
    if (fontVariantKeyword) {
        return { type: 'keyword', keyword: fontVariantKeyword };
    }
    return null;
}
/**
 * Convert FontVariantValue back to CSS string
 */
function toCSSValue(parsed) {
    if (!parsed) {
        return null;
    }
    // Handle CSS variables
    if ('CSSvariable' in parsed) {
        return (0, css_variable_1.toCSSValue)(parsed);
    }
    if ('keyword' in parsed) {
        return parsed.keyword;
    }
    return null;
}
